<template>
    <div class="shop-container">
        <swiper-small :list="bannerArr"/>

        <div class="class-list" v-if="hot.length > 0">
            <!-- 热门视频 -->
            <div class="class-title"><span></span>{{$t('hot')}}{{$t('video')}}</div>
            <div class="class-item-wrap">
                <div class="class-item" v-for="item in hot" :key="item.id" @click="detail(item)">
                    <!-- <img :src="item.cover" alt="" > -->
                    <div class="videp-cover" :style="{backgroundImage: `url(${item.cover})`, backgroundSize: 'cover'}"></div>
                    <img v-if="item.price > 0" class="vip" src="@/assets/images/video/vip.png" alt="">
                    <div class="title">{{item.title}}</div>
                    <div class="bot">
                        <!-- 作者： -->
                        <span>{{$t('author')}}：{{item.author}}</span>
                        <!-- <span>浏览量：0</span> -->
                        <!-- 浏览量：0 -->
                        <span>{{$t('views')}}：{{item.pv}}</span>
                    </div>
                </div>
            </div>
        </div>


        <div class="class-list" v-for="items in commonList" :key="items.id">
            <div class="class-title">
                <div class="title-wrap">
                    <span></span>{{items.type_name}}
                </div>
                 <router-link :to="{name:'videoclassify',query:{id: items.id}}" >
                    <!-- <i>更多</i> -->
                    <i>{{$t('more')}}</i>
                </router-link>
            </div>
            <div class="class-item-wrap">
                <div class="class-item" v-for="item in items.course.list" :key="item.id" @click="detail(item)">
                    <!-- <img class="videp-cover" :src="item.cover" alt=""> -->
                    <div class="videp-cover" :style="{backgroundImage: `url(${item.cover})`, backgroundSize: 'cover'}"></div>
                    <img v-if="item.price > 0" class="vip" src="@/assets/images/video/vip.png" alt="">
                    <div class="title">{{item.title}}</div>
                    <div class="bot">
                        <!-- 作者： -->
                        <span>{{$t('author')}}：{{item.author}}</span>
                        
                        <!-- 浏览量：0 -->
                        <span>{{$t('views')}}：{{item.pv}}</span>
                    </div>
                </div>
            </div>
        </div>


        
    </div>
</template>

<script>
import Loft from "@/components/video/Loft.vue";
import SwiperSmall from '@/components/common/SwiperSmall.vue'
export default {
    components: {
        SwiperSmall,
        Loft
    },
    data() {
        return {
            bannerArr: [],
            loftData: [],
            form: {
                page: 1,
                limit: 10,
                where: {
                    is_hot: 1
                }
            },
            hot: [], // 热门视频
            commonList: [] // 普通视频
        }
    },
    mounted() {
        this.getBanner()
        this.list('hot')
        this.floatList()
    },
    methods: {
        floatList() {
            this.$api.getcourselist().then(res => {
                if(res.status) {
                    this.commonList = res.data.list
                }
            })
        },
        // 获取轮播图s
        getBanner() {
            this.$api.slider({
                code: 'pc_video_home_slide'
            }).then(res => {
                if (res.status) {
                    this.bannerArr = res.data.list;
                }
            });
        },
        initParams() {
            let copy = JSON.parse(JSON.stringify(this.form))
            copy.where = JSON.stringify(copy.where)
            return copy
        },
        list(value) {
            let params = this.initParams()
            this.$api.courseGetlist(params).then( res => {
                this[value] = res.data.list
            })
        },
        detail(item) {
            this.$router.push({
                name: 'videodetail',
                params: {
                    videoId: item.id
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/mixin.scss';
@import '@/assets/css/variable.scss';
.class-list {
    background: #ffffff;
    width: 1226px;
    margin: 20px auto 0;
    padding: 30px;
    margin-bottom: 20px;
    box-sizing: border-box;
}
.class-title {
    color: #333333;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
        display: inline-block;
        width: 6px;
        height: 38px;
        background: #FF6D6D;
        border-radius: 4px;
        margin-right: 7px;
    }
    .title-wrap {
        display: flex;
        align-items: center;
    }
}
.class-item-wrap {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .class-item{
        width: 220px;
        margin-top: 20px;
        margin-bottom: 10px;
        margin-left: 16px;
        padding: 10px;
        cursor: pointer;
        position: relative;
        box-sizing: border-box;
        &:hover {
            box-shadow: 0 15px 20px rgba(0,0,0,0.1);
        }
        .vip {
            position: absolute;
            right: 10px;
            top: 10px;
            width: 50px;
            height: 26px;
        }
        &:first-child {
            margin-left: 0;
        }
        &:nth-child(6n) {
            margin-left: 0;
        }
        .videp-cover {
            width: 200px;
            height: 121px;
            border-radius: 10px;
        }
        .title {
            height: 38px;
            margin: 10px 0;
            line-height: 20px;
            @include no-wrap-line(2)
        }
        .bot{
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
    }
}
</style>